import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { State } from '../../../store/reducers';
import { Router } from '@angular/router';
import * as bookingActions from '../../../store/actions/booking.action';
import { Booking } from '../../models/booking';
import { Observable } from 'rxjs/Observable';
import { find, filter } from 'rxjs/operators';

@Component({
  selector: 'app-roomchoice',
  templateUrl: './roomchoice.component.html',
  styleUrls: ['./roomchoice.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RoomchoiceComponent implements OnInit {
  public opened = false;
  roomchoiceinfoForm: FormGroup;
  rooms: any[];
  hotelList: any[];
  // roomItems;
  standardSingle = ['Premier Hotel'];
  standardSharing = [
    'Garden Court(OR.Tambo)',
    'Sun OR tambo',
    'Sun 1 Edenvale',
    'Sun 1 Berea'
  ];
  deluxeSingle = ['Sandton(southern Sun)'];
  deluxeSharing = [];

  // @ViewChild('validationModal') modal: any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private store: Store<State>
  ) {}

  ngOnInit() {
    this.store
      .select(state => state.booking.availableRooms)
      .subscribe(rooms => (this.rooms = rooms));
    this.createForm();
    // this.roomItems = this.rooms$.filter((_, index) => index % 2 === 0);
    // this.store
    //   .select(state => state.booking.currentBooking)
    //   .subscribe(booking => this.createForm(booking));
  }

  createForm() {
    this.roomchoiceinfoForm = this.fb.group({
      packageChoice: ['', Validators.required],
      hotelChoice1: ['', Validators.required],
      hotelChoice2: ['', Validators.required],
      hotelChoice3: ['', Validators.required]
    });
  }

  closeModal() {
    this.opened = false;
  }

  openModal(roomName) {
    this.hotelList = this.rooms.find(r => r.name === roomName).hotels;
    this.roomchoiceinfoForm.get('packageChoice').setValue(roomName);
    // this.modal.open();
    this.opened = true;
  }

  submitRoomChoice() {
    // console.log(this.roomchoiceinfoForm.value);
    this.closeModal();
    this.store.dispatch(
      new bookingActions.AddRoomInfo(this.roomchoiceinfoForm.value)
    );
    this.router.navigate(['/bookings/add/tour-info']);
  }

  cancel() {
    this.router.navigate(['/bookings']);
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/form-components/roomchoice/roomchoice.component.ts